import React from "react";

export default function AudioViewer({ id, keySet, filePathToSet }) {
  return (
    <audio id={id} key={keySet} controls>
      <source src={filePathToSet} type="audio/mpeg"></source>
    </audio>
  );
}
